import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDragHandle]',
  standalone: false
})
export class DragHandleDirective {

  constructor(public elementRef: ElementRef<HTMLElement>) { }

}
